import { List } from 'immutable';
import CommunicationSubscriptionNotOpted from '../../../filterQueryFormat/operator/CommunicationSubscriptionNotOpted';
import CommunicationSubscriptionOptIn from '../../../filterQueryFormat/operator/CommunicationSubscriptionOptIn';
import CommunicationSubscriptionOptOut from '../../../filterQueryFormat/operator/CommunicationSubscriptionOptOut';
import { communicationChannelToFilterFamily } from '../communicationSubscriptionFilters/communicationSubscriptionFilters';
import { HAS_NOT_OPTED, HAS_OPTED_IN, HAS_OPTED_OUT } from '../ObjectSegOperatorTypes';
const OperatorNameToOperatorConstructor = Object.freeze({
  [HAS_OPTED_IN]: CommunicationSubscriptionOptIn,
  [HAS_OPTED_OUT]: CommunicationSubscriptionOptOut,
  [HAS_NOT_OPTED]: CommunicationSubscriptionNotOpted
});
export const fromCommunicationSubscriptionFilter = (filter, getField, __converterOptions) => {
  const filterFamily = communicationChannelToFilterFamily(filter.channel);
  const Operator = OperatorNameToOperatorConstructor[filter.acceptedOptStates[0]];
  const field = getField([filterFamily]);
  const condition = Operator.of(
  //@ts-expect-error Operator field and getField return types do not match
  field, List(filter.subscriptionIds).map(id => String(id)));
  return condition;
};